<template>
  <div>
    <grid
      :config="gridConfig"
      @handleCustomButtonGrid="onCustomButtonGrid"
      class="no-grid-border"
      ref="grid"
    >
      <template  v-slot:column-control-right="{ row }">
        <li>
          <el-button style="line-height: 1;" size="mini" @click="copyStock({ row })" type="info" icon="el-icon-copy-document">
            {{L10n('copy-to-clipboard')}}
          </el-button>
        </li>
      </template>
    </grid>
    <dialog-stock-card ref="dialog-stock-card" />
  </div>
</template>

<script>
import createGridConfig from './GridConfig'
import { waitValue } from '@/utils/promises'
import { ServiceStocks } from '@/services/Stocks'

export default {
  name: 'StocksGridIndex',
  components: {
    'grid': () => import(/* webpackChunkName: 'Grid' */ '@/components/Grid/Index'),
    'dialog-stock-card': () => import(/* webpackChunkName: 'DialogStockCard' */ '@/components/Shared/Activity/DialogStockCard')
  },
  props: {
    isPreview: { type: Boolean, default: false },
    data: { type: Object }
  },
  watch: {
    'data': {
      immediate: true,
      handler () {
        let { partID } = this.data || {}
        if (!partID) return
        return this.getGrid()
          .then((grid) => {
            let filters = `partID == ${partID}`
            grid.setFilters(filters)
            grid.loadData()
          })
      }
    }
  },
  computed: {
    gridConfig () {
      return createGridConfig({ isPreview: this.isPreview })
    }
  },
  methods: {
    getGrid () {
      return waitValue(() => this.$refs['grid'])
    },
    onCustomButtonGrid ({ row, button }) {
      switch (button.action) {
        case 'STOCK_CARD':
          return this.handleStockCard({ row })
        case 'REPAIR_STATUS_CARD':
          return this.handleOpenRepairStatus({ row })
        default:
          this.handlerAddToRFQ3({ row, button })
      }
    },
    modelRFQ3 () {
      return {
        rfqid: null,
        quoteDate: new Date(),
        partID: null,
        partSN: '',
        qty: 1,
        conditionID: null,
        price: null,
        currencyID: null,
        traceabilityCompanyID: null,
        tagInfoCompanyID: null,
        tagDate: null,
        releaseID: null,
        stockID: null,
        exchangeCoreValue: '',
        exchangeCoreValueCurrencyID: null,
        supplyDate: ''
      }
    },
    handleOpenRepairStatus ({ row }) {

    },
    handleStockCard ({ row }) {
      this.$refs['dialog-stock-card'].show(row.id)
    },
    handlerAddToRFQ3 ({ row }) {
      let otherFields = {
        price: row.sellPrice,
        currencyID: row.sellExchCurrencyID,
        exchangeCoreValueCurrencyID: row.sellExchCurrencyID,
        supplyDate: row.locationTitle,
        qty: row.qty
      }
      let data = this.copyObjectProps(this.modelRFQ3(), { ...this.data, ...row, ...otherFields })
      this.$emit('add-to', data)
    },
    makeClipboardText ({ row }) {
      return ServiceStocks.makeStockTextInfo(row)
    },
    async copyToClipboard (text) {
      if (!text) {
        return
      }

      try {
        await navigator.clipboard.writeText(text)

        this.$notify.success({
          title: this.L10n('success'),
          message: this.L10n('copied-to-clipboard')
        })
      } catch {
        this.$notify.error({
          title: this.L10n('error'),
          message: this.L10n('failed-to-copy')
        })
      }
    },
    copyStock ({ row }) {
      const res = this.makeClipboardText({ row })
      this.copyToClipboard(res)
    }
  }
}
</script>
